import { AccordionBodyItem } from 'component/Accordion';
import React from 'react';

const autoMessage = (
  <span>
    Зону звіту буде визначено автоматично
    <br />
    Report zone will be determined automatically
  </span>
);

export const ReportZone = (props) => {
  const fileZone = props.formData?.info?.general?.file_zone ?? props.formData?.file_zone ?? '';
  return (
    <AccordionBodyItem accordionSubId={null} titleUA="Зона звіту" titleEN="Report zone">
      {fileZone || autoMessage}
    </AccordionBodyItem>
  );
};
